import React, {useContext, useMemo, useState} from 'react';
import {UserContext} from '../../src/contexts/UserContext';
import MessageReceiver from '../../src/components/Chat/MessageReceiver/MessageReceiver';
import AttachmentsPreviews from '../../src/components/Chat/AttachmentsPreviews/AttachmentsPreviews';
import app from '../../src/helpers/app';
import ConfirmableButton from '../../src/components/ConfirmableButton/ConfirmableButton';
import trans from '../../src/helpers/trans';
import {TableBodyProps} from '../../src/@types/components/List';

export default function OrderListDeleteItemButton(props: {
    onClick: Parameters<NonNullable<TableBodyProps['renderControls']>>[2],
}) {
    const userContext = useContext(UserContext);
    const [attachments, setAttachments] = useState<File[]>([]);
    const [message, setMessage] = useState<string | null>(null);

    const [onDrop, onDelete] = useMemo(() => {
        const onDrop: React.ComponentProps<typeof MessageReceiver>['onDrop'] = (attachments) => {
            setAttachments(list => [...list, ...attachments]);
        };

        const onDelete: React.ComponentProps<typeof AttachmentsPreviews>['onDelete'] = (index) => {
            setAttachments(list => {
                list.splice(index, 1);

                return [...list];
            });
        };

        return [onDrop, onDelete];
    }, []);

    const canDropOrderDirectly = userContext?.can(
            app('names-resolver').permissions.getDeleteRoutePermissionName('order')
    ) === true;

    return <ConfirmableButton
            size="sm"
            color="danger"
            title={trans('List.controls.delete')}
            popoverTitle="List.actions.delete.popover-title"
            confirmButtonLabel="List.actions.delete.confirm-button-label"
            cancelButtonLabel="List.actions.delete.cancel-button-label"
            popoverBody={
                canDropOrderDirectly ? undefined : <MessageReceiver
                        defaultValue={message}
                        onInput={setMessage}
                        onDrop={onDrop}
                        placeholder="OrdersIndex.placeholders.enter-reason"
                        filesPreviewSlot={
                            <AttachmentsPreviews attachment={attachments} onDelete={onDelete}/>
                        }
                />
            }
            onClick={async () => {
                props.onClick({reason: {message, attachments}}).then(success => {
                    if (!success) {
                        return;
                    }

                    setAttachments([]);
                    setMessage(null);
                });
            }}
    >
        <i className="fa fa-trash"/>
    </ConfirmableButton>;
}
